import React from "react";
import "./testimonial.css";

function Testimonial() {
  const testimonials = [
    {
      text: "“Aplikasi ini sangat berguna untuk melacak pengeluaran dan pemasukan sehari-hari saya. Antarmukanya bersih dan intuitif”",
      name: "Arina Putri",
      rating: 5,
      image: "/Images/1.jpg",
    },
    {
      text: "“Di dashboard, ringkasan bulanan dan tampilan grafik sangat membantu saya memahami kemana uang saya pergi.”",
      name: "Sandika Flores",
      rating: 5,
      image: "/Images/2.jpg",
    },
    {
      text: "“Sangat menyukai aplikasi ini! Sangat mudah untuk mencatat pengeluaran dan melihat persis kemana uang saya pergi setiap bulan.”",
      name: "Anisa Sari",
      rating: 5,
      image: "/Images/3.jpg",
    },
  ];

  return (
    <section className="testimonial-section">
      <div className="testimonial-container">
        {testimonials.map((item, index) => (
          <div key={index} className="testimonial-card">
            {/* Rounded photo on top */}
            <div className="user-photo-wrapper">
              <img
                src={item.image}
                alt={item.name}
                className="user-photo-top"
              />
            </div>

            <div className="stars">{"★".repeat(item.rating)}</div>
            <p className="testimonial-text">{item.text}</p>

            <div className="testimonial-user">
              <span className="user-name">{item.name}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Testimonial;
